import(/* webpackMode: "eager" */ "/opt/render/project/src/apps/dashboard/app/(routes)/error.tsx");
